module.exports = __webpack_public_path__ + "img/categorie-accesoires-famille-boutrais.a2cd7955.jpg";